import { VStack, Heading, Box } from '@chakra-ui/react';
import { ForgotPasswordFooter, ForgotPasswordForm } from 'domains/account/forgot-password';
import { getIdentityLayout } from 'layouts';
import { CustomNextPage, RoleLevels } from 'lib/types';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';

const { publicRuntimeConfig: { baseRESTPort, genericSubDomain, baseDomain, basePort, baseProtocol, genericRESTUrl, enableEncryptedPacks }} = getConfig();

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  let host = ctx.req.headers.host;
  host = host.replace(/(^\w+:|^)\/\//, '');

  const requestBaseUrl = host.replace(basePort || '80', baseRESTPort || '443');
  const baseUrl = `${baseProtocol || 'http'}://${requestBaseUrl}/v1/`;

  if (!baseUrl.startsWith(genericRESTUrl)) {
    return {
      redirect: {
        permanent: false,
        destination: `${baseProtocol}://${genericSubDomain}${baseDomain}${basePort}/forgot-password`,
      }
    }
  }

  return { props: {} }
}

const ForgotPassword: CustomNextPage = () => (
  <VStack spacing={10}>
    <Heading variant="auth-title" size="lg">Forgot your password?</Heading>
    {enableEncryptedPacks && (
      <Box>
        Warning: Resetting your password will prevent you from accessing encrypted packs that you created or that were shared with you. The only way to access an encrypted pack after a password reset is to use your current password. Non-encrypted packs are not affected by this.
      </Box>
    )}
    <ForgotPasswordForm />
    <ForgotPasswordFooter />
  </VStack>
);

ForgotPassword.getLayout = getIdentityLayout;
ForgotPassword.allowedRoles = [ RoleLevels.OPEN ];

export default ForgotPassword;
